import React from 'react';
import { CalendarDays } from 'lucide-react';
import { CopyTextButton } from './CopyTextButton';
import { mapName, monsterName } from '../../utils/worldFormat';
import { positionConditions, positionLabel, type EventPosition } from '../../utils/eventPositions';
import type { WorldData } from '../../types/world';

/** Posiciones dentro de un evento. Se rotulan como temporales: no son spots permanentes. */
export function EventPositionList({
  w,
  positions,
  max = 3,
  showMonster = false
}: {
  w: WorldData;
  positions: EventPosition[];
  max?: number;
  showMonster?: boolean;
}) {
  if (!positions.length) return null;
  return <div className="mt-1.5" data-id="element-1223" data-mp="3bmco0cwx76hp">
      <p className="flex items-center gap-1.5 text-[11px] font-semibold text-sky-200" data-id="element-1224" data-mp="3blkrmzvi14qd">
        <CalendarDays className="h-3.5 w-3.5" aria-hidden="true" data-id="element-1225" data-mp="37l93ve7uaoao" />
        Disponible durante el evento
        <span className="font-normal text-sky-200/70" data-id="element-1226" data-mp="209jx14byem2p">· no es un spot permanente</span>
      </p>
      <ul className="mt-1 space-y-1" data-id="element-1227" data-mp="1w52grf4syqwo">
        {positions.slice(0, max).map(p => {
        const ev = p.eventId ? w.events.get(p.eventId)?.name ?? p.eventId : undefined;
        const maps = p.mapIds.map(id => mapName(w, id));
        const mapText = maps.length === 0 ? 'mapa del evento sin resolver' : maps.length === 1 ? maps[0] : `uno de: ${maps.join(', ')}`;
        return <li key={p.id} className="flex flex-wrap items-center gap-x-2 gap-y-0.5" data-id="element-1228" data-mp="q541ticmbcw0">
              {showMonster && <span className="text-sm text-gray-200" data-id="element-1229" data-mp="cdpmblhx5ttp">{monsterName(w, p.monsterId)}</span>}
              <span className="font-mono text-[13px] text-gray-200" data-id="element-1230" data-mp="h6sd5lvbap67">{positionLabel(p)}</span>
              <span className="text-xs text-gray-500" data-id="element-1231" data-mp="2ifg0lkhn0a4">
                {mapText} · {positionConditions(p)}
                {ev ? ` · ${ev}` : ''}
              </span>
              <CopyTextButton iconOnly text={`${monsterName(w, p.monsterId)} — ${mapText} — ${positionLabel(p)}${ev ? ` (durante ${ev})` : ''}`} label="Copiar ubicación" data-id="element-1232" data-mp="3plahbci4tkkj" />
            </li>;
      })}
        {positions.length > max && <li className="text-xs text-gray-500" data-id="element-1233" data-mp="205gl2nbodnsh">+{positions.length - max} posiciones más en el evento</li>}
      </ul>
    </div>;
}